const state = {
  currentStep: 1,
  registerFields: {
    customerName: '',
    streetName: '',
    houseNumber: '',
    houseNumberAdd: '',
    zipCode: '',
    city: '',
    email: '',
    phoneNumber: '',
    chamberOfCommerceNumber: '',
    vatNumber: '',
    contactFirstName: '',
    contactMiddleName: '',
    contactLastName: '',
    contactFunction: '',
    contactEmail: '',
    contactPhoneNumber: '',
  },
  errorRegisterFields: [],
  isLoading: false,
  isComplete: false,
}

export default state
